// extracted by mini-css-extract-plugin
export default {"container":"LegalData_container__h88cr","link":"LegalData_link__Ay4yB"};